import { createBrowserRouter, Navigate } from "react-router";
import { useMe } from "../lib/queries";
import { OverviewPage } from "../features/overview/OverviewPage";
import { ConversationsTab } from "../features/project/ConversationsTab";
import { KnowledgeTab } from "../features/project/KnowledgeTab";
import { LinksTab } from "../features/project/LinksTab";
import { PlaygroundTab } from "../features/project/PlaygroundTab";
import { ProjectLayout } from "../features/project/ProjectLayout";
import { ReportPage } from "../features/project/ReportPage";
import { SaldoTab } from "../features/project/SaldoTab";
import { SettingsTab } from "../features/project/SettingsTab";
import { SummaryTab } from "../features/project/SummaryTab";
import { TestRunPage } from "../features/project/TestRunPage";
import { TestsTab } from "../features/project/TestsTab";
import { SettingsPage } from "../features/settings/SettingsPage";
import { EmptyState } from "../ui/Feedback";
import { AppShell } from "./AppShell";

export const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { index: true, element: <Home /> },
      {
        path: "projects/:projectId",
        element: <ProjectLayout />,
        children: [
          { index: true, element: <SummaryTab /> },
          { path: "knowledge", element: <KnowledgeTab /> },
          { path: "links", element: <LinksTab /> },
          { path: "playground", element: <PlaygroundTab /> },
          { path: "tests", element: <TestsTab /> },
          { path: "conversations", element: <ConversationsTab /> },
          { path: "saldo", element: <SaldoTab /> },
          { path: "settings", element: <SettingsTab /> },
        ],
      },
      // Printable documents live outside the tab chrome.
      { path: "projects/:projectId/tests/:runId", element: <TestRunPage /> },
      { path: "projects/:projectId/report", element: <ReportPage /> },
      { path: "settings", element: <SettingsPage /> },
      // The sign-in form shows at any address; signing in at /login should land on the portfolio.
      { path: "login", element: <Navigate to="/" replace /> },
      { path: "*", element: <EmptyState title="Halaman tidak ditemukan">Periksa kembali alamatnya, atau kembali ke ringkasan portofolio.</EmptyState> },
    ],
  },
]);

/** Staff land on the portfolio; a client account goes straight to its own project. */
function Home() {
  const me = useMe().data!;
  return me.role === "client" && me.projectId ? <Navigate to={`/projects/${me.projectId}`} replace /> : <OverviewPage />;
}
